import React, { useState } from 'react'
import { MenuItem, Modal, Select } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Skeleton from 'react-loading-skeleton'
import { useLoad, usePutRequest } from '../../../shared/hooks/requests'
import { TENANT_BLACKLIST_TYPES, TENANT_SET_BLACKLIST } from '../../../shared/utils/urls'
import { useMessage } from '../../../shared/hooks/message'

export function AddBlackListModal({ id }) {
    const showMessage = useMessage()
    const [changes, setChanges] = useState('')
    const [open, setOpen] = useState(false)
    const loadTypes = useLoad({ url: TENANT_BLACKLIST_TYPES }, [open])
    const postBlacklist = usePutRequest()
    const types = loadTypes.response ? loadTypes.response : []
    const typesOption = types?.map((type) => ({ value: type.id, label: type.description }))

    const submit = async () => {
        const { success } = await postBlacklist.request({
            url: TENANT_SET_BLACKLIST,
            params: {
                tenant_entity_id: id,
                black_list_type_id: changes,
            },
        })
        if (success) {
            setOpen(false)
            showMessage('successfully added', 'success-msg')
        }
    }

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                className="px-[15px] font-[500] py-[5px]
                                             bg-main-100 text-white rounded-[10px]"
            >
                Add blacklist
            </button>

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                className="flex items-center justify-center"
            >
                <div className="w-[300px] rounded-[10px] flex flex-col p-[15px] gap-[20px] h-auto  bg-white">
                    <div className="w-full flex items-center justify-between">
                        <span className="text-[14px] font-[600] text-black">Add Blacklist</span>
                        <CloseIcon onClick={() => setOpen(false)} />
                    </div>
                    <div className="w-full flex flex-col items-center gap-[40px]">
                        <Select
                            variant="outlined"
                            displayEmpty
                            renderValue={(value) => (value
                                ? typesOption.find((v) => v.value === value)?.label : 'Choose type')}
                            sx={{ height: '100%', width: '100%' }}
                            value={changes}
                            disabled={!typesOption.length}
                            onChange={(e) => setChanges(e.target.value)}
                        >
                            {!loadTypes.loading && types.length ? (
                                typesOption.map((menuItem) => (
                                    <MenuItem key={menuItem.value} value={menuItem.value}>
                                        {menuItem?.label}
                                    </MenuItem>
                                ))
                            ) : loadTypes.loading ? (
                                <MenuItem>
                                    <Skeleton width="50%" height={30} />
                                </MenuItem>
                            ) : (
                                <MenuItem value="">Nothing Found</MenuItem>
                            )}
                        </Select>
                        <button
                            onClick={submit}
                            className="px-[15px] font-[500] py-[10px] w-full
                                             bg-main-100 text-white rounded-[10px]"
                        >
                            Add blacklist
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    )
}
